import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const InjectMassage = (props) => <><i className={props.id}></i><FormattedMessage {...props} /></>;

export default injectIntl(InjectMassage, {
  withRef: false,
});
